import { render, staticRenderFns } from "./DxWorkOrders.vue?vue&type=template&id=abb7a66a&scoped=true&"
import script from "./DxWorkOrders.vue?vue&type=script&lang=js&"
export * from "./DxWorkOrders.vue?vue&type=script&lang=js&"
import style0 from "./DxWorkOrders.vue?vue&type=style&index=0&id=abb7a66a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb7a66a",
  null
  
)

export default component.exports